<div class="row justify-content-center mb-4">
  @for (card of cards; track $index; let last = $last) {
  <div [class]="last ? 'col-12 col-md-6 col-lg-4' : 'col-12 col-md-6 col-lg'">
    <groundworks-metrics-card [metrics]="card.metrics" [state]="card.state" />
  </div>
  }
</div>
